'use client'

import {Collapse as KitCollapse, CollapseProps} from 'antd'
import styled from 'styled-components'

import {BodySelector} from '@/src/config/settings'

export interface SpoilersProps {
  className?: string
  items: CollapseProps['items']
  onChange?: (key: string | string[]) => void
  activeKey?: string[]
}

export const Collapse = (props: SpoilersProps) => (
  <Component>
    <KitCollapse {...props} expandIconPosition="end" accordion />
  </Component>
)

const Component = styled.div`
  ${BodySelector} & .ant-collapse-header {
    align-items: center;
  }
`
